import useChatMessages from '@/composables/chat/actions/messages'
import useChatAttendances, { closedAttendance, newAttendance, transferedAttendance, updateAttendanceTags, syncClientTags } from '@/composables/chat/actions/attendances'
import { useChatStore } from '@/stores/chat'
import { useChatGroups } from '@/stores/chat/groups'
import { useChatAttendance } from '@/stores/chat/attendances'
import { useUsersStore } from '@/stores/users'
import { useCRM } from '@/stores/crm/crm';
import { notify } from '@kyvg/vue3-notification'
import audioFile from '@/assets/audio/alertWaiting.mp3'
import { handleTelephonyEvent } from '@/composables/telephony/useTelephonyEvents'
import { handleTelephonyOmnichannelEvent, handleCallStatusEvent } from '@/composables/telephony/useTelephonyOmnichannelEvents'




const store = useChatStore()
const storeAttendances = useChatAttendance()
const storeGroups = useChatGroups()

const GROUP_ACTIONS = new Set([
    'group_join',
    'group_joined',
    'group_leave',
    'group_left',
    'group_add_user',
    'group_remove_user',
    'group_users_added',
    'group_users_removed',
    'group_refresh',
    'group_mute',
    'group_muted',
    'group_mute_all',
    'group_muted_all',
    'client_photo_refresh',
    'client_photo_updated',
])

function getGroupErrorAction(data, dataV2) {
    return [
        data?.action,
        data?.request_action,
        data?.data?.action,
        data?.data?.request_action,
        data?.v2?.action,
        dataV2?.action,
        dataV2?.request_action,
    ].find((action) => GROUP_ACTIONS.has(action))
}

/**
* @param {Object} data Message received to WebSocket, consult useWebSocket.js
* @returns {void}
*/
export const dispatchActions = (data) => {
    const execute = data?.v2?.type_beta
        || (data?.v2?.type === 'chat' ? data?.v2?.action : data?.v2?.type)
        || (data?.type === 'chat' ? data?.action : null)
        || data?.type
        || data?.action
        || (data?.error ? 'error' : null)
        || null
    const dataV2 = data?.v2?.data || null

    const chatConfig = store().chatConfig;
    const userStore = useUsersStore()
    const crmStore = useCRM();

    // Trata o payload da notification para exibir a mensagem vinda de notification.content
    const notificationContent = data?.v2?.data?.notification;
    if (typeof notificationContent !== 'undefined' && notificationContent !== null) {

        var horaAtual = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        // Verifica se o panelMessages tem mais de 10 mensagens
        if (store().panelMessages.length >= 10) {
            store().panelMessages.shift();
        }
        store().panelMessages.push(`${horaAtual} - ${notificationContent.content}`);

    }

    switch (execute) {


        case 'notify_waiting_attendances':

            if (chatConfig.waiting_tolerance_avoid_admin && userStore.isAdmin) { return } // se for admin pula a verificação
            if (!chatConfig.waiting_tolerance_enabled) { return }
            if (!chatConfig.waiting_tolerance_popup) { return }
            if (storeAttendances().waiting.length <= chatConfig.waiting_tolerance_attendances) { return }

            notify({
                type: 'warning',
                title: 'Atendimentos em espera',
                text: 'Existem atendimentos esperando por atendimento. Verifique a aba Em espera dos atendimentos.',
                duration: -1,
            })

            if (!chatConfig.waiting_tolerance_sound) { return }
            var audio = new Audio(audioFile);
            audio.play();
            break

        case 'status':

            if (storeAttendances().currentAttendance?.id == data.data.attendance_id) {

                storeAttendances().isTyping = true

                // Depois de 4 segundos, define como false
                setTimeout(() => {
                    storeAttendances().isTyping = false;

                }, 4000);

            }

            break

        case 'connection_has_opened':
            alert('Você já está conectado em outro dispositivo.')
            store().websocket.status = 'Disconnected'
            //alert('Você já está conectado em outro dispositivo.')
            break

        case 'new_message':



            if (data?.v2?.data?.messages[0]?.attendance_step == 'automation') {

                const attendanceId = data?.data?.attendance_id;
                const attendance = storeAttendances().automation.find(attendance => attendance.id == attendanceId)
                if (attendance) {
                    attendance.system_tags = data?.v2?.data?.system_tags
                }

            }

            useChatMessages.receiveMessage(data.v2)


            break

        //separar a lógica do attendance transferred de new attendance
        case 'attendance_transferred':

            transferedAttendance(dataV2);

            break;

        case 'new_attendance':
            //case 'attendance_transferred':


            newAttendance(dataV2, false, false)
            break

        case 'attendance_updated':

            updateAttendanceTags(dataV2)

            break

        case 'sync_client_tags':

            syncClientTags(dataV2)

            break

        case 'next_automation':


            if (data?.data?.automation?.v2?.type == "attendance_closed") {

                closedAttendance(Number(data?.data?.automation?.v2?.data?.id), 'automation', data?.data?.automation?.v2?.data?.action)
                store().refreshClosedDaily()

            }

            break;

        case 'attendance_remove':
        case 'attendance_closed':


            closedAttendance(Number(dataV2.id), dataV2.step, dataV2?.action)
            store().refreshClosedDaily()

            /*if(data?.v2?.data?.type == "attendance_closed"){

                const found = storeAttendances()[dataV2.step].find((attendance) => attendance.id === dataV2.id)
                storeAttendances().closed.push(found)

            }*/

            break

        case 'deleted':

            useChatMessages.markAsDeleted(data.data, data.data.message_id)

            break

        case 'closed_attendance':
            useChatAttendances.remove(data.v2.data.id, data.v2.data.step)
            store().refreshClosedDaily()
            break

        case 'users_online':
            store().online_users = dataV2.users
            break

        case 'edit_messages':
            const messages = data.v2.data.messages
            messages.forEach(message => {
                useChatAttendances.updateEditedMessage(message.attendance_id, message.id, message.content)
            })
            break
        case 'message_updated_ack':
            const acks = data?.data?.acks
            const groupAcks = data?.data?.group_acks

            if (Array.isArray(acks) && acks.length) {
                useChatMessages.updateAck(acks)
            }

            if (Array.isArray(groupAcks) && groupAcks.length) {
                storeGroups().updateAck(groupAcks)
            }

            break
        case 'automation':

            const attendanceId = data?.data?.attendance_id
            const storeAtt = storeAttendances();
            const id = Number(attendanceId);

            // Todas as listas possíveis onde o item pode estar
            const lists = [
                storeAtt.progress,
                storeAtt.waiting,
                storeAtt.audit?.progress,
                storeAtt.audit?.waiting
            ];

            let removedObject;
            // Percorre cada lista e remove se encontrar
            for (const list of lists) {
                if (!Array.isArray(list)) continue; // ignora se for undefined ou não for array

                const index = list.findIndex(item => item.id === id);
                if (index !== -1) {


                    [removedObject] = list.splice(index, 1);
                    removedObject.chat_step = "automation"
                    removedObject.user_id = null;



                }
            }

            const existingItem = storeAttendances().automation.find(existing => existing.id === attendanceId);
            if (!existingItem) {
                storeAttendances().automation.push(removedObject);
            }

            storeAttendances().automationLoader = false;

            notify({
                type: 'success',
                title: 'Pronto',
                text: 'Atendimento enviado com sucesso para a automação',
            })

            break


        case 'failed_message':
            let message = dataV2?.message
            if (dataV2?.link) {
                message += `<br/><br/><a href="${dataV2?.link}" target="_blank" class="!text-inherit font-bold">Clique para mais informações</a>`
            }

            notify({
                type: 'error',
                title: dataV2?.title,
                text: message,
                duration: 10000,
            })
            break

        case 'telephony_event':
            handleTelephonyEvent(data.data)
            break

        case 'telephony_omnichannel':
            handleTelephonyOmnichannelEvent(dataV2)
            break

        case 'call_status':
            handleCallStatusEvent(data?.data)
            break

        case 'channel_status':
            {
                const channelData = data.data
                if (channelData) {
                    const chId = String(channelData.channel_id)
                    const chStatus = channelData.channel_status
                    const chName = channelData.channel_name

                    const channel = store().channels.find(c => String(c.id) === chId)
                    if (channel) {
                        channel.status = chStatus
                    }

                    const isOffline = chStatus === 'disconnected'
                    
                    const message = isOffline
                        ? `O canal ${chName} está offline. Verifique o celular e confirme se está tudo certo.`
                        : `O canal ${chName} está online novamente.`

                    notify({
                        type: isOffline ? 'error' : 'success',
                        title: `Canal ${chName}`,
                        text: message,
                        duration: isOffline ? 5000 : 3000,
                    })
                }
            }
            break

        case 'new_negotiation':


            crmStore.newNegotiation(
                {
                    clients: [],
                    attendances: [],
                    tasks: [],
                    ...dataV2
                })


            break

        case 'new_group_message':
            storeGroups().receiveGroupMessage(data?.data || dataV2)
            break

        case 'group_join':
        case 'group_joined':
            storeGroups().groupJoined(data?.data || dataV2)
            break

        case 'group_leave':
        case 'group_left':
            storeGroups().groupLeft(data?.data || dataV2)
            break

        case 'group_users_added':
            storeGroups().groupUsersAdded(data?.data || dataV2)
            notify({
                type: 'success',
                title: 'Grupo atualizado',
                text: data?.message || 'Usuários adicionados ao grupo.',
            })
            break

        case 'group_users_removed':
            storeGroups().groupUsersRemoved(data?.data || dataV2)
            notify({
                type: 'success',
                title: 'Grupo atualizado',
                text: data?.message || 'Usuários removidos do grupo.',
            })
            break

        case 'group_refresh':
            storeGroups().groupRefreshed(data?.data || dataV2)
            notify({
                type: 'success',
                title: 'Grupo atualizado',
                text: data?.message || 'As informações do grupo foram atualizadas.',
            })
            break

        case 'group_muted':
            storeGroups().groupMuted(data?.data || dataV2)
            break

        case 'group_muted_all':
            storeGroups().groupMutedAll(data?.data || dataV2)
            break

        case 'client_photo_updated':
            storeGroups().participantPhotoUpdated(data?.data || dataV2)
            notify({
                type: 'success',
                title: 'Foto atualizada',
                text: data?.message || 'A foto do participante foi atualizada.',
            })
            break

        case 'group_deleted':
            storeGroups().groupDeleted(data?.data || dataV2)
            break

        case 'error': {
            const errorMessage = data?.error || data?.message || dataV2?.message || 'Não foi possível concluir a operação.'
            const groupAction = getGroupErrorAction(data, dataV2)

            if (groupAction) {
                storeGroups().groupActionFailed(
                    errorMessage,
                    groupAction,
                    data?.data || dataV2,
                )
            }

            notify({
                type: 'error',
                title: 'Erro',
                text: errorMessage,
            })
            break
        }

        default:
        // console.warn('[chat] Unknown action: ' . execute, data)
    }
}
